import { UIRouterReact } from '@uirouter/react';
import { authService } from '@logz-pkg/frontend-services';
import { stateRedirections } from './stateRedirection';
import { NEW_APP_ROOT } from './resolve-new-app-url';
import { getIsNewAppEnabled } from 'ui/hooks/is-new-application-enabled.hook';

export let isRedirectingToNewApp = false;

export function registerNewApplication(appRouter: UIRouterReact) {
  appRouter.transitionService.onBefore({}, async transition => {
    if (authService.isAuthenticated()) {
      const stateName = transition.to().name;
      const params = transition.params();

      // If the user does not have permission to use the old application, the `isEnabled` flag
      // will always resolve to `true`. In that case, we *must* send them to the new application.
      // We try to generate a redirect URL for the new app. If generating the URL fails, we still
      // redirect them to the new app as a fallback.
      //
      // If the user has access to *both* the old and the new applications,
      // and generating a redirect URL fails, then we simply allow the transition
      // to proceed normally so they stay within the old app.
      //
      // `isAllowedOnOldApp` will be true only when:
      //   - The feature flag for the new app router is turned OFF, and
      //   - The user is *not* a new account (new accounts cannot access the old app)
      //
      // When `isAllowedOnOldApp` is false, the user is not permitted to stay in the old app.
      // In that case, even if we fail to build a redirect URL, we fall back to redirecting
      // them to `/360` in the new application.
      getIsNewAppEnabled().then(({ isEnabled, isAllowedOnOldApp }) => {
        if (isEnabled) {
          let url = stateRedirections[stateName ?? '']?.(params);

          if (!url && !isAllowedOnOldApp) {
            url = NEW_APP_ROOT;
          }

          if (url) {
            isRedirectingToNewApp = true;
            window.location.replace(url);
          }
        }
      });
    }
  });
}
